import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import LoginScreen from '../screens/auth/LoginScreen';
import WelcomeScreen from '../screens/auth/WelcomeScreen';
import RegisterStep1Screen from '../screens/auth/RegisterStep1Screen';
import RegisterStep2Screen from '../screens/auth/RegisterStep2Screen';
import RegisterStep3Screen from '../screens/auth/RegisterStep3Screen';
import StoreSetupStep1Screen from '../screens/auth/StoreSetupStep1Screen';
import StoreSetupStep2Screen from '../screens/auth/StoreSetupStep2Screen';

const Stack = createNativeStackNavigator();

const AuthNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{headerShown: false}}
      initialRouteName="Welcome">
      <Stack.Screen name="Welcome" component={WelcomeScreen} />
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="RegisterStep1" component={RegisterStep1Screen} />
      <Stack.Screen name="RegisterStep2" component={RegisterStep2Screen} />
      <Stack.Screen name="RegisterStep3" component={RegisterStep3Screen} />
      <Stack.Screen name="RegisterStep4" component={StoreSetupStep1Screen} />
      <Stack.Screen name="RegisterStep5" component={StoreSetupStep2Screen} />
    </Stack.Navigator>
  );
};

export default AuthNavigator;
